import type { GraphTooltipPayloadType } from 'components/Graph/GraphTooltip/GraphTooltipPayload';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface HideTooltipCommand {
  type: GraphTooltipPayloadType;
}

export const hideTooltip: GraphCommandFactory<HideTooltipCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      if (draft.tooltip?.payload.type === command.type) {
        draft.tooltip = null;
      }
    });
  };
